module.exports = __webpack_public_path__ + "media/images/tak_mil_icon-8fd0060bcbfd01bcd584fd875388c20f.png";